export const iconFontAwesomeHalloweenCrow = (
	<i className="fa-solid fa-crow"></i>
);
